import type { tAccountErrorCode } from 'src/providers/SocketsProvider/Sockets.types';

/**
 * Every WhatsApp Web disconnect code this front renders, mirroring
 * whatsapp-web-service's `AccountErrorCodes`. A Record over the union, so the
 * build fails when a code is added to `tAccountErrorCode` and not here.
 */
const KNOWN_ACCOUNT_ERROR_CODES: Record<tAccountErrorCode, true> = {
  BANNED: true,
  DEVICE_REMOVED: true,
  SESSION_INVALIDATED: true,
  CONNECTION_TIMEOUT: true,
  RECOVERABLE_WHATSAPP_ERROR: true,
  USER_LOGGED_OUT: true,
  PROVIDER_DELETED: true,
  NO_ACCOUNT: true,
  WHATSAPP_RESTRICTED: true,
  UNKNOWN: true,
};

function isAccountErrorCode(value: string): value is tAccountErrorCode {
  return Object.prototype.hasOwnProperty.call(KNOWN_ACCOUNT_ERROR_CODES, value);
}

/**
 * The disconnect code to render for a raw value from the REST status or the
 * `account_update` socket event: a known code as is, any other non-empty
 * string as `UNKNOWN`, and null when there is no code.
 *
 * Both sources carry the code as a plain string typed as `tAccountErrorCode`,
 * but nothing checked it, so a code the backend shipped before the front knew
 * it made the status modal crash on `STATUS_CONFIG[code]` (INT-1649).
 */
export function toAccountErrorCode(value: unknown): tAccountErrorCode | null {
  if (typeof value !== 'string' || value === '') return null;

  return isAccountErrorCode(value) ? value : 'UNKNOWN';
}
